<owc-table style="padding: 10px;">
  <owc-table-header sticky>
    <owc-table-header-cell>
      <owc-checkbox style="height: 25px;"
        [checked]="isAllSelected()"
        [indeterminate]="isIndeterminate()"
        (change)="masterToggle()">
      </owc-checkbox>
    </owc-table-header-cell>
    <owc-table-header-cell sortable [align]="'left'" (sortOrderChange)="OnSort('customerID', $event.detail)">
      Account ID
    </owc-table-header-cell>
    <owc-table-header-cell sortable [align]="'left'" (sortOrderChange)="OnSort('customerName', $event.detail)">
      Account Name
    </owc-table-header-cell>
    <owc-table-header-cell sortable [align]="'left'" (sortOrderChange)="OnSort('customerContactName', $event.detail)">
      Account Contact Name
    </owc-table-header-cell>
    <owc-table-header-cell sortable [align]="'left'" (sortOrderChange)="OnSort('customerContactEmail', $event.detail)">
      Account Contact Email
    </owc-table-header-cell>
    <owc-table-header-cell sortable [align]="'left'" (sortOrderChange)="OnSort('Source', $event.detail)">
      Source
    </owc-table-header-cell>
    <owc-table-header-cell style="width: 80px; min-width: 80px; max-width: 80px;"></owc-table-header-cell>
    <owc-table-header-cell style="width: 40px; min-width: 40px; max-width: 40px;"></owc-table-header-cell>
    <owc-table-header-cell style="width: 40px; min-width: 40px; max-width: 40px;"></owc-table-header-cell>
  </owc-table-header>
  <owc-table-body>
    @for (element of (dataSource | async); track $index) {
      <owc-table-row>
        <owc-table-simple-cell>
          <owc-checkbox
            [checked]="isSelected(element)"
            (change)="toggleSelection(element)">
          </owc-checkbox>
        </owc-table-simple-cell>
        <owc-table-simple-cell [title]="element.customerID">
          <div *ngIf="element.customerID || element.customerID == null; else natEditablecustomerID"
               class="truncate-text" [title]="element.customerID">
            {{ element?.customerID }}
          </div>
          <ng-template #natEditablecustomerID>
            <owc-input appearance="outline" class="noadd-template-txt-box nat-customerId-column-input" placeholder="Enter text..."
                   [formControl]="getControl($index, 'customerID')" required />
          </ng-template>
        </owc-table-simple-cell>
        <owc-table-simple-cell [title]="element.customerName">
          <div *ngIf="element.customerName || element.customerName == null; else natEditablecustomerName"
               class="truncate-text" [title]="element.customerName">
            {{ element.customerName }}
          </div>
          <ng-template #natEditablecustomerName>
            <owc-input appearance="outline" class="noadd-template-txt-box nat-customername-column-input" placeholder="Enter text..."
                   [formControl]="getControl($index, 'customerName')" required />
          </ng-template>
        </owc-table-simple-cell>
        <owc-table-simple-cell [title]="element.customerContactName">
          <div *ngIf="element.customerContactName || element.customerContactName == null; else natEditablecustomerContactName"
               class="truncate-text" [title]="element.customerContactName">
            {{ element.customerContactName }}
          </div>
          <ng-template #natEditablecustomerContactName>
            <owc-input appearance="outline" class="noadd-template-txt-box nat-customercontactname-column-input" placeholder="Enter text..."
                   [formControl]="getControl($index, 'customerContactName')" required />
          </ng-template>
        </owc-table-simple-cell>
        <owc-table-simple-cell [title]="element.customerContactEmail">
          <div *ngIf="element.customerContactEmail || element.customerContactEmail == null; else natEditablecustomerContactEmail"
               class="truncate-text" [title]="element.customerContactEmail">
            {{ element.customerContactEmail }}
          </div>
          <ng-template #natEditablecustomerContactEmail>
            <owc-input type="email" appearance="outline" class="noadd-template-txt-box nat-customercontactemail-column-input" placeholder="Enter email..."
                   [formControl]="getControl($index, 'customerContactEmail')" required />
          </ng-template>
        </owc-table-simple-cell>
        <owc-table-simple-cell [title]="element.source">
          <owc-chip *ngIf="element.source || element.source == null; else natEditablesource"
                    class="truncate-text" [title]="element.source">
            {{ element.source }}
          </owc-chip>
          <ng-template #natEditablesource>
            <owc-input appearance="outline" class="noadd-template-txt-box nat-source-column-input" placeholder="Enter text..."
                   [formControl]="getControl($index, 'source')" required />
          </ng-template>
        </owc-table-simple-cell>
        <owc-table-simple-cell style="text-align: center; width: 80px; min-width: 80px; max-width: 80px;">
          <button style="border: none; background: none;" one-icon-button *ngIf="element.iconSets === 'yes-No-icon'">
                     <owc-icon (click)="addNewNotificationRecipient(element, $index, 'yes')" name="confirm" family="outlined"></owc-icon>
          </button>
          <button style="border: none; background: none;" one-icon-button *ngIf="element.iconSets === 'yes-No-icon'">
            <owc-icon (click)="addNewNotificationRecipient(element, $index, 'no')" name="no" family="outlined"></owc-icon>
          </button>
        </owc-table-simple-cell>
        <!-- Warning icon column -->
        <owc-table-simple-cell style="text-align: center; width: 40px; min-width: 40px; max-width: 40px;">
          <div *ngIf="isDuplicate(duplicates, element) || isEmpty(element, $index)">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" style="width: 24px; height: 24px;" title="Duplicate recipient warning">
              <path fill="#D0342C" d="M21.912 20.173L12.813 3.478c-.265-.442-.795-.618-1.237-.353a.69.69 0 0 0-.353.353L2.125 20.173c-.265.442-.089.972.353 1.237.088.088.265.088.442.088h18.197c.53 0 .883-.441.883-.883 0-.177 0-.265-.088-.442zm-9.01-2.208h-1.767v-1.767H12.9v1.767zm0-3.534h-1.767v-5.3H12.9v5.3z"></path>
            </svg>
          </div>
        </owc-table-simple-cell>
        <!-- Expand/collapse column -->
        <owc-table-simple-cell style="text-align: center; width: 40px; min-width: 40px; max-width: 40px;">
          <div *ngIf="isDuplicate(duplicates, element) || isEmpty(element, $index)" style="cursor: pointer; display: inline-flex; align-items: center; justify-content: center;" (click)="expandToggle(element)">
            <svg *ngIf="element != expandedElement" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="width: 24px; height: 24px; fill: #333;">
              <path d="M7 10l5 5 5-5z"/>
            </svg>
            <svg *ngIf="element == expandedElement" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="width: 24px; height: 24px; fill: #333;">
              <path d="M7 14l5-5 5 5z"/>
            </svg>
          </div>
        </owc-table-simple-cell>
      </owc-table-row>
      <!-- Detail row for warnings -->
      <owc-table-row class="detail-row" *ngIf="element == expandedElement && (isDuplicate(duplicates, element) || isEmpty(element, $index))">
        <owc-table-simple-cell class="expanded-detail-cell">
          <div class="element-detail">
            <div style="padding: 12px 16px; background-color: transparent; border-left: 4px solid #0073e6; margin: 0;">
              <div *ngIf="isDuplicatedEmail(duplicates,element)" style="color: #333; font-size: 14px; margin-bottom: 4px;">
                Duplicated contact email for the same Account ID.
              </div>
              <div *ngIf="isDuplicatedName(duplicates,element)" style="color: #333; font-size: 14px; margin-bottom: 4px;">
                Different Account name for existing Account ID.
              </div>
              <div *ngIf="isEmpty(element, $index)" style="color: #333; font-size: 14px; margin-bottom: 4px;">
                Fields cannot be empty or blank.
              </div>
            </div>
          </div>
        </owc-table-simple-cell>
        <owc-table-simple-cell style="display:none;"></owc-table-simple-cell>
        <owc-table-simple-cell style="display:none;"></owc-table-simple-cell>
        <owc-table-simple-cell style="display:none;"></owc-table-simple-cell>
        <owc-table-simple-cell style="display:none;"></owc-table-simple-cell>
        <owc-table-simple-cell style="display:none;"></owc-table-simple-cell>
        <owc-table-simple-cell style="display:none;"></owc-table-simple-cell>
        <owc-table-simple-cell style="display:none;"></owc-table-simple-cell>
        <owc-table-simple-cell style="display:none;"></owc-table-simple-cell>
      </owc-table-row>
    }
  </owc-table-body>
</owc-table>
<p class="add-recipient-text"
   [ngStyle]="{'display': controls.value.length > 0 ? 'none' : 'block'}">
  Click on “Add recipients” to add additional recipients.
</p>
